import slice from './slice';

export const { setCollapse, setSelectedOrder, setOrderFormData, setAssignedDrone, setAssignMethod, setMissionId, setSelectedMissionTemplate } = slice.actions;